import React from "react";
import { motion } from "framer-motion";
import { FiGithub, FiExternalLink } from "react-icons/fi";
// import MovieLand from "../assets/MovieLand.png";
import WEGYM from "../assets/WEGYM.png";
import EDUMatch from "../assets/dashboardetudiant.jpg";
import BakraouiImg from "../assets/logocabinet.png";


const projects = [
  {
    id: 1,
    title: "Cabinet Dentaire Bakraoui",
    description:
      "Full web platform for a dental clinic: online appointment booking, services and team pages, and a secure admin dashboard with PDF export.",
    tags: ["React", "Express", "MySQL", "Tailwind", "Auth", "PDF Export"],
    image: BakraouiImg,
    live: "https://www.centre-dentaire-bakraoui.com/",
    repos: [
      { label: "Frontend", url: "https://github.com/mohammedyassinAa/Bakraoui" },
      { label: "Backend", url: "https://github.com/mohammedyassinAa/bakraoui-backend" },
    ],
  },
  {
    id: 2,
    title: "EDUMatch",
    description:
      "Educational platform connecting students with tutors using smart matching.",
    tags: ["Laravel", "Vue.js", "WebSockets"],
    image: EDUMatch,
    github: "https://github.com/EduMatch-PFA/EduMatch",
  },
  {
    id: 3,
    title: "WEGYM",
    description:
      "Comprehensive fitness platform with workout tracking and community features.",
    tags: ["Full-Stack", "MERN Stack", "Redux"],
    image: WEGYM,
    github: "https://github.com/mohammedyassinAa/WEGYM",
  },
  // {
  //   id: 4,
  //   title: "MovieLand",
  //   description:
  //     "A responsive movie discovery application with filtering capabilities.",
  //   tags: ["React", "API Integration", "Tailwind CSS"],
  //   image: MovieLand,
  //   github: "https://github.com/mohammedyassinAa/Movie-Land",
  // },
];

const Portfolio = () => {
  return (
    <div
      name="Projects"
      id="Projects"
      className="w-full min-h-screen transition-colors duration-300
                 bg-gradient-to-b from-gray-50 via-white to-gray-100
                 dark:from-gray-900 dark:via-black dark:to-gray-800"
    >
      <div className="max-w-6xl mx-auto px-6 sm:px-8 py-16 md:py-20 flex flex-col justify-center">
        {/* Section header */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.5 }}
          className="mb-12 md:mb-16"
        >
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 inline-block text-gray-900 dark:text-white">
            My Projects
            <span className="block mt-2 h-1 w-24 bg-gradient-to-r from-cyan-500 to-blue-600 rounded"></span>
          </h2>
          <p className="text-gray-700 dark:text-gray-300 text-base sm:text-lg max-w-3xl">
            Selected work across QA-minded development, real-world client apps, and full‑stack solutions.
          </p>
        </motion.div>

        {/* Projects grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {projects.map((project, index) => (
            <motion.article
              key={project.id}
              initial={{ y: 40, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.45, delay: index * 0.08 }}
              className="group rounded-xl overflow-hidden border shadow-sm
                         bg-white/70 border-gray-200
                         dark:bg-gray-800/50 dark:border-gray-700
                         hover:border-cyan-400/60 hover:shadow-cyan-500/10 transition-all duration-300"
            >
              {/* Image or fallback */}
              <div className="relative overflow-hidden">
                {project.image ? (
                  <img
                    src={project.image}
                    alt={`${project.title} preview`}
                    loading="lazy"
                    className="w-full h-48 sm:h-56 object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                ) : (
                  <div
                    className="w-full h-48 sm:h-56 flex items-center justify-center
                               bg-gradient-to-br from-cyan-500 to-blue-600 text-white"
                  >
                    <span className="text-xl font-semibold">{project.title}</span>
                  </div>
                )}

                <div
                  className="pointer-events-none absolute inset-0 flex items-end p-4
                             bg-gradient-to-t from-black/70 via-black/10 to-transparent
                             opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                >
                  <div>
                    <h3 className="text-lg sm:text-xl font-bold text-white">
                      {project.title}
                    </h3>
                    <p className="text-gray-200 text-sm line-clamp-2">
                      {project.description}
                    </p>
                  </div>
                </div>
              </div>

              {/* Body */}
              <div className="p-5 sm:p-6">
                {/* Tags */}
                <div className="flex flex-wrap gap-2 mb-4">
                  {project.tags.map((tag) => (
                    <span
                      key={tag}
                      className="text-xs px-2 py-1 rounded border
                                 bg-gray-100 text-cyan-700 border-cyan-100
                                 dark:bg-gray-700 dark:text-cyan-400 dark:border-gray-600"
                    >
                      {tag}
                    </span>
                  ))}
                </div>

                {/* Links */}
                <div className="flex flex-wrap gap-3">
                  {project.live && (
                    <a
                      href={project.live}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`Open ${project.title} live site`}
                      className="inline-flex items-center gap-2 text-sm font-medium
                                 text-cyan-700 hover:text-cyan-800
                                 dark:text-cyan-400 dark:hover:text-cyan-300 transition-colors"
                    >
                      <FiExternalLink className="text-lg" /> Live Site
                    </a>
                  )}

                  {/* Support either single github or multiple repos */}
                  {project.repos
                    ? project.repos.map((r) => (
                      <a
                        key={r.url}
                        href={r.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={`View ${project.title} ${r.label} code on GitHub`}
                        className="inline-flex items-center gap-2 text-sm font-medium
                                     text-gray-700 hover:text-cyan-600
                                     dark:text-gray-300 dark:hover:text-cyan-400 transition-colors"
                      >
                        <FiGithub className="text-lg" /> {r.label}
                      </a>
                    ))
                    : project.github && (
                      <a
                        href={project.github}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={`View ${project.title} code on GitHub`}
                        className="inline-flex items-center gap-2 text-sm font-medium
                                     text-gray-700 hover:text-cyan-600
                                     dark:text-gray-300 dark:hover:text-cyan-400 transition-colors"
                      >
                        <FiGithub className="text-lg" /> View Code
                      </a>
                    )}
                </div>
              </div>
            </motion.article>
          ))}
        </div>

        {/* Footer CTA */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ delay: 0.2, duration: 0.4 }}
          className="mt-16 md:mt-20 text-center"
        >
          <p className="text-lg md:text-xl text-gray-700 dark:text-gray-300 mb-6">
            Want to see more of my work?
          </p>
          <a
            href="https://github.com/mohammedyassinAa"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-gradient-to-r from-cyan-500 to-blue-600 px-6 py-3 rounded-lg font-medium text-white
                       hover:shadow-lg hover:shadow-cyan-500/20 active:scale-[0.98] transition-all duration-300"
          >
            <FiGithub /> Visit My GitHub
          </a>
        </motion.div>
      </div>
    </div>
  );
};

export default Portfolio;